/**
 * Region-aware price formatting.
 * Delegates to currency.js which uses Intl.NumberFormat.
 */
import { formatPrice as currencyFormatPrice } from './currency';

export function formatPrice(num) {
  return currencyFormatPrice(num);
}
